const SYSTEM_SNIPPETS = [
  {
    name: "for",
    description: "A for loop snippet to iterate over a range of numbers.",
    code: "for (number|/*iterator*/ = /*initialVal*/;/*condition*/; /*iterator*/ = /*iterator*/ + 1) {\n  /*body*/\n}",
  },
];

export default SYSTEM_SNIPPETS;
